module.exports = __webpack_public_path__ + "assets/img/files-brain.0b42bb5a.svg";